import { render, staticRenderFns } from "./cmpRec.vue?vue&type=template&id=27c51d5d&"
import script from "./cmpRec.vue?vue&type=script&lang=js&"
export * from "./cmpRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports